import { useState } from "react";
import axios from "axios";
import { Wand2, Loader2, Undo2 } from "lucide-react";
import { EDITOR } from "@/constants/testIds";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AiImproveButton({ data, onImproved }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [previous, setPrevious] = useState(null);

    const handleImprove = async () => {
        setBusy(true);
        setError(null);
        const before = data.message || "";
        try {
            const res = await axios.post(`${API}/improve-text`, {
                text: before,
                primary_name: data.primary_name || "",
                secondary_name: data.secondary_name || "",
            });
            const improved = res.data?.improved || "";
            if (!improved) throw new Error("Empty response");
            setPrevious(before);
            onImproved(improved);
        } catch (e) {
            console.error(e);
            setError("No hemos podido mejorar el texto. Inténtalo otra vez.");
        } finally {
            setBusy(false);
        }
    };

    const handleUndo = () => {
        if (previous === null) return;
        onImproved(previous);
        setPrevious(null);
    };

    return (
        <div className="mt-3">
            <div className="flex flex-wrap items-center gap-2">
                <button
                    type="button"
                    data-testid={EDITOR.aiImproveBtn}
                    onClick={handleImprove}
                    disabled={busy}
                    className="ai-wand-btn"
                >
                    {busy ? (
                        <Loader2 size={14} className="animate-spin" />
                    ) : (
                        <Wand2 size={14} />
                    )}
                    {busy ? "Puliendo tu texto..." : "Mejorar texto con IA"}
                </button>
                {previous !== null && !busy && (
                    <button
                        type="button"
                        data-testid="btn-ai-undo"
                        onClick={handleUndo}
                        className="btn-ghost"
                        style={{ padding: "8px 14px", fontSize: 12 }}
                    >
                        <Undo2 size={12} />
                        Deshacer
                    </button>
                )}
            </div>
            {error && <p className="hint-error">{error}</p>}
            {!error && !busy && (
                <p className="text-[11px] text-[var(--ink-soft)] mt-2 leading-relaxed">
                    Lo reescribimos en segundos con un tono elegante y emotivo.
                    Tú decides si te gusta.
                </p>
            )}
        </div>
    );
}
